module.exports = __webpack_public_path__ + "static/media/chodba-prizemi-zadni-cela2.a7ceea23.jpg";